import { FetchJson } from './Fetch';

const teachersAPI = {
    signUpInstructor:(data) => FetchJson.post( `/teachers`,data),
    getTeacherProfile:() => FetchJson.get( `/teachers`),
    postChangeEmail:(data:object) => FetchJson.post("/teachers/profile/account-setting", data),
    postCodeVerify:(data:object) => FetchJson.post("/teachers/profile/code-verification", data),
    postChangePw:(data:object) => FetchJson.post("/teachers/account", data),
    patchProfile:(data:object) => FetchJson.patch("/teachers/profile", data),
    postProfileImg:(data:object) => FetchJson.post("/teachers/image", data),
    getTeacherProfileByAdmin:(id) => FetchJson.get( `/admin-users/teachers/${id}`),
    getTeacherUrlCheck:(url) => FetchJson.get( `/teachers/public-url/${url}`),
    getTeacherEmailCheck:(email) => FetchJson.get( `/teachers/email/${email}`),
}

export { teachersAPI };